import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { Confirmation } from './common';
import { messageUtility } from '../../utilities/messageUtility';

/**
 * 作業予定・実績に工種を削除する確認ダイアログ
 * @props {string}type:BS0003_使用工種選択画面またはBS0005工種ごと設定画面で使われるダイアログの判断フラグ
 * @props {string}isSubWorkType:小工種かどうか判断するフラグ
 */
export const ProgressConfirmDialog = ({
  visible,
  onCancel,
  onConfirm,
  listWorkDelete,
  type,
  isSubWorkType,
  fieldMainWorkType,
  fieldSubWorkType,
  negativeButtonClassName,
}) => {
  const listWorkDeleteRef = useRef(null);
  const isTypeLocation = type === 'location';

  const renderListWorkDelete = () =>
    _.map(listWorkDelete, (work, index) => (
      <li className='ProgressConfirmDialog__work' key={index}>
        {isTypeLocation ? work.name.trim() : work}
      </li>
    ));

  useEffect(() => {
    if (
      listWorkDeleteRef.current &&
      listWorkDeleteRef.current.offsetHeight >= 300
    ) {
      listWorkDeleteRef.current.classList.add(
        'ProgressConfirmDialog__list--scroll'
      );
    }
  });

  const renderMessage = () => {
    return (
      <React.Fragment>
        {!_.isEmpty(listWorkDelete) && (
          <React.Fragment>
            <div>
              {isTypeLocation
                ? '以下の作業場所についての内容が修正されました。集計対象としていた場所のチェックを外した箇所が集計対象から削除されます。'
                : '計画を登録済の工種が選択解除されました。このまま更新すると、以下の工種の計画は削除されます。'}
            </div>
            {isTypeLocation && (
              <div className='ProgressConfirmDialog__template-title'>
                {`工種 ：${fieldMainWorkType.name} ${
                  isSubWorkType ? `- ${fieldSubWorkType.name}` : ''
                }`}
              </div>
            )}
            <ul
              className={`ProgressConfirmDialog__list ${isTypeLocation &&
                'ProgressConfirmDialog__list--location'}`}
              ref={listWorkDeleteRef}
            >
              {renderListWorkDelete()}
            </ul>
          </React.Fragment>
        )}
        <p>更新してよろしいですか？</p>
      </React.Fragment>
    );
  };

  return (
    <Confirmation
      visible={visible}
      title={fieldMainWorkType ? '場所の更新' : '使用工種の更新'}
      message={renderMessage()}
      confirmButtonText='計画を削除して更新'
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      isNegative={true}
      onConfirm={onConfirm}
      onCancel={onCancel}
      multilineText={true}
      rootClassName='ProgressConfirmDialog'
      negativeButtonClassName={negativeButtonClassName}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ProgressConfirmDialog.jsx